export enum AlertStatus {
  Resolved = 468190000,
  NoActionRequired = 468190001,
  New = 468190002,
  Acknowledged = 468190003
}

export const AlertStatusLabels: Record<AlertStatus, string> = {
  [AlertStatus.Resolved]: 'Resolved',
  [AlertStatus.NoActionRequired]: 'No Action Required',
  [AlertStatus.New]: 'New',
  [AlertStatus.Acknowledged]: 'Acknowledged'
};

export interface Alert {
  id: string;
  createdOn: string;
  messageId: string;
  status: AlertStatus;
  isActive: boolean;
  summary: string;
  detail?: string | null;
  statusChangedBy?: string | null;
  statusChangedOn?: string | null;
  notes?: string | null;
}

export interface AlertsListQuery {
  pageSize?: number;
  cursor?: string;
  active?: boolean;
  status?: AlertStatus;
  createdFrom?: string;
  createdTo?: string;
  messageId?: string;
  q?: string;
  changedBy?: string;
}

export interface AlertPatch {
  status?: AlertStatus;
  isActive?: boolean;
  notes?: string | null;
}

export interface AlertBulkPatchRequest {
  ids: string[];
  patch: AlertPatch;
}

export interface AlertBulkPatchFailure {
  id: string;
  code: string;
  message: string;
}

export interface AlertBulkPatchResult {
  updated: number;
  failed: AlertBulkPatchFailure[];
}

export interface AlertCounts {
  activeCount: number;
  newCount: number;
}

export interface AlertMessageResponse {
  messageId: string;
  record: {
    raw: Record<string, unknown>;
  };
}

export interface AlertStepRecord {
  raw: Record<string, unknown>;
}

export interface AlertStepsResponse {
  messageId: string;
  steps: AlertStepRecord[];
}

export interface AlertSingleResponse {
  item: Alert;
}

export interface AlertApiError {
  error: string;
  status: number;
  timestamp: string;
}
